// Author : Ayesha Shaikh
// Date : 30 july 2024

import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";

import FilterButtonComponent from "../../newComponent/NewButtonComp/FilterButtonComponent";

import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import WalkinDetailedReport from "./WalkinDetailedReport";
import SubserviseWalkinReport from "./SubserviseWalkinReport";
import { useEffect, useState } from "react";
import AdvisorWiseWalkinReport from "./AdvisorWiseWalkinReport";
import BranchWiseReport from "./BranchWiseReport";

export default function WalkInReport() {
  const [selectedChip, setSelectedChip] = useState("detailedreport");
  const [open, setOpen] = useState(false);
const userRole=localStorage.getItem("userRole")
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleChipClick = (criteria) => {
    setSelectedChip(criteria);
    setOpen(false);
  };

  useEffect(() => {
    if (selectedChip !== "detailedreport") {
      setOpen(true);
    }
  }, [selectedChip]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={2} sm={4} md={3}>
          <HeadingCard>
            <Typography variant="h3" textAlign="center">
              {" "}
              Walk-in Report
            </Typography>
          </HeadingCard>
        </Grid>

        <Grid item xs={12} md={12} sm={12} lg={12}>
          <Grid container>
            <Grid item xs={12} md={8} sm={12} lg={8}>
              <Grid container gap={2}>
                <Button
                  size="small"
                  style={{
                    fontWeight: selectedChip === "detailedreport" ? 600 : 500,
                    background:
                      selectedChip === "detailedreport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "detailedreport" ? "#364152" : "white",
                    border:
                      selectedChip !== "detailedreport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("detailedreport")}
                >
                  Detailed Report
                </Button>


                <Button
                  size="small"
                  style={{
                    fontWeight:
                      selectedChip === "subServicewisereport" ? 600 : 500,
                    background:
                      selectedChip === "subServicewisereport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "subServicewisereport"
                        ? "#364152"
                        : "white",
                    border:
                      selectedChip !== "subServicewisereport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("subServicewisereport")}
                >
                  Sub Service Wise Specific Report
                </Button>
           

     {!["trainer"].includes(userRole) && ( 
                <Button
                  size="small"
                  style={{
                    fontWeight:
                      selectedChip === "advisorWiseReport" ? 600 : 500,
                    background:
                      selectedChip === "advisorWiseReport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "advisorWiseReport"
                        ? "#364152"
                        : "white",
                    border:
                      selectedChip !== "advisorWiseReport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("advisorWiseReport")}
                >
                Appointment For Specific Report
                </Button>
     )}
             
             

{!["advisor","trainer"].includes(userRole) && ( 
                       <Button
                  size="small"
                  style={{
                    fontWeight:
                      selectedChip === "branchWiseReport" ? 600 : 500,
                    background:
                      selectedChip === "branchWiseReport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "branchWiseReport"
                        ? "#364152"
                        : "white",
                    border:
                      selectedChip !== "branchWiseReport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("branchWiseReport")}
                >
                  Branch Visited Specific Report
                </Button>
                )}
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              sm={12}
              lg={4}
              display="flex"
              justifyContent="flex-end"
            >
              <FilterButtonComponent
                onClick={handleToggle}
                text="Filter"
                open={open}
                showendIcon={true}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {selectedChip === "detailedreport" && (
            <WalkinDetailedReport open={open} />
          )}
          {selectedChip === "subServicewisereport" && (
            <SubserviseWalkinReport open={open} />
          )}
          {selectedChip === "advisorWiseReport" && (
            <AdvisorWiseWalkinReport open={open} />
          )}

      {selectedChip === "branchWiseReport" && (
            <BranchWiseReport open={open} />
          )}
          
        </Grid>
      </Grid>
    </>
  );
}
